<template>
  <div>
    <BarChart v-if="USER_INFO.change_user" />
    <div v-if="USER_INFO.gruppa === 'super'">
      <button
        class="btn btn-sm btn-outline-success shadow-none m-1"
        @click="add_news()"
        data-toggle="modal"
        data-target="#exampleModal"
      >
        добавить новость
      </button>
    </div>
    <div v-for="n of news" :key="n.id" class="card">
      <div class="card-body">
        <h5 class="card-title">{{ n.header_news }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ n.date_news }}</h6>
        <p class="card-text" v-html="n.text_news"></p>
        <div v-if="USER_INFO.status === 'admin' && n.likes">
          <span class="badge badge-success m-1 p-2">{{ n.e_like }}</span>
          <span class="badge badge-danger m-1 p-2">{{ n.not_like }}</span>
        </div>
        <div v-if="USER_INFO.gruppa === 'super'">
          <i
            class="bi bi-pencil-square m-1"
            @click="edit_news(n)"
            data-toggle="modal"
            data-target="#exampleModal"
          ></i
          ><i class="bi bi-trash m-1" @click="delete_news(n.id)"></i>
        </div>
        <div v-if="n.likes && !n.like_status">
          <button
            class="btn btn-sm btn-outline-success shadow-none m-1"
            @click="set_like(1, n.id)"
          >
            хорошая новость
          </button>
          <button
            class="btn btn-sm btn-outline-danger shadow-none m-1"
            @click="set_like(0, n.id)"
          >
            лучше по старому
          </button>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="USER_INFO.gruppa === 'super'"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Добавление новости
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="m-1">
              <input
                type="text"
                class="form-control shadow-none"
                placeholder="заголовок"
                v-model="new_news_header"
              />
            </div>
            <div class="m-1">
              <textarea
                type="text"
                class="form-control shadow-none"
                placeholder="текст"
                v-model="new_news_text"
              />
            </div>
            <div>
              <a href="" @click.prevent="add_line_break" class="m-1"
                >вставить перенос строки</a
              >
              <a href="" @click.prevent="add_url" class="m-1"
                >вставить ссылку</a
              >
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary shadow-none"
              data-dismiss="modal"
            >
              Закрыть
            </button>
            <button
              type="button"
              class="btn btn-primary shadow-none"
              data-dismiss="modal"
              @click="save_news"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTPGET } from "@/api";
import BarChart from "@/components/BarChart.vue";
import { mapGetters } from "vuex";
export default {
  name: "News",
  components: {
    BarChart
  },
  computed: {
    ...mapGetters(["USER_INFO"])
  },
  data: () => ({
    news: null,
    new_news_header: "",
    new_news_text: "",
    edit_news_flag: false,
    edit_news_id: null
  }),
  mounted() {
    this.get_data();
  },
  methods: {
    get_data() {
      HTTPGET("home/news/get_news.php").then(
        response => (this.news = response.data)
      );
    },
    set_like(i, id) {
      HTTPGET({
        url: "home/news/set_like_news.php",
        params: {
          like: i,
          news_id: id
        }
      }).then(() => this.get_data());
    },
    add_line_break() {
      this.new_news_text += "<br>";
    },
    add_url() {
      this.new_news_text +=
        "<a href='адрес ссылки' target='blank'>название ссылки</a>";
    },
    save_news() {
      let url;
      if (this.edit_news_flag) {
        url = "home/news/edit_news.php";
      } else {
        url = "home/news/add_news.php";
      }
      HTTPGET({
        url: url,
        params: {
          header: this.new_news_header,
          text: this.new_news_text,
          id: this.edit_news_id
        }
      })
        .then(() => this.get_data())
        .then(() => {
          this.edit_news_flag = false;
        });
    },
    delete_news(id) {
      if (confirm("точно удалить?")) {
        HTTPGET({
          url: "home/news/delete_news.php",
          params: {
            id: id
          }
        }).then(() => this.get_data());
      }
    },
    edit_news(n) {
      this.new_news_header = n.header_news;
      this.new_news_text = n.text_news;
      this.edit_news_id = n.id;
      this.edit_news_flag = true;
    }
  }
};
</script>
<style scoped>
.card {
  margin-bottom: 5px;
  font-size: 0.8em;
}
.bi {
  cursor: pointer;
}
</style>
